export default [
  {
    path: "/Report/SummaryReport",
    name: "SummaryReport",
    component:  () => import("@/components/Report/SummaryReport.vue"),
    meta: {
        name: "SummaryReport",
        menuTitle: "Summary Report",
        requiresAuth: true
    },
    props: true
  },
  {
    path: "/Print/ShowPrintBAIK",
    name: "PrintBAIK",
    component:  () => import("@/components/Report/ShowPrintBAIK.vue"),
    meta: {
        name: "PrintBAIK",
        menuTitle: "Print BAIK",
        requiresAuth: true
    },
    props: true
  },
  {
    path: "/Print/ShowPrintKom",
    name: "PrintKom",
    component:  () => import("@/components/Report/ShowPrintKom.vue"),
    meta: {
        name: "PrintKOM",
        menuTitle: "Print KOM",
        requiresAuth: true
    },
    props: true
  },
  {
    path: "/Print/ShowPrintDelay",
    name: "PrintDelay",
    component:  () => import("@/components/Report/ShowPrintDelay.vue"),
    meta: {
        name: "PrintDelay",
        menuTitle: "Print Delay",
        requiresAuth: true
    },
    props: true
  },
  {
    path: "/Print/ShowPrintPenalty",
    name: "PrintPenalty",
    component:  () => import("@/components/Report/ShowPrintPenalty.vue"),
    meta: {
        name: "PrintPenalty",
        menuTitle: "Print Penalty",
        requiresAuth: true
    },
    props: true
  },
  {
    path: "/Print/ShowPrintAddendum",
    name: "PrintAddendum",
    component:  () => import("@/components/Report/ShowPrintAddendum.vue"),
    meta: {
        name: "PrintAddendum",
        menuTitle: "Print Addendum",
        requiresAuth: true
    },
    props: true
  },
  {
    path: "/Print/ShowPrintMCAddendum",
    name: "PrintMCAddendum",
    component:  () => import("@/components/Report/ShowPrintMCAddendum.vue"),
    meta: {
        name: "PrintMCAddendum",
        menuTitle: "Print MC Addendum",
        requiresAuth: true
    },
    props: true
  },
  {
    path: "/Print/ShowPrintTermin",
    name: "PrintTermin",
    component:  () => import("@/components/Report/ShowPrintTermin.vue"),
    meta: {
        name: "PrintTermin",
        menuTitle: "Print Termin",
        requiresAuth: true
    },
    props: true
  },
  {
    path: "/Print/ShowPrintQcFinal",
    name: "PrintQCFinal",
    component:  () => import("@/components/Report/ShowPrintQcFinal.vue"),
    meta: {
        name: "PrintQCFinal",
        menuTitle: "Print QC Final",
        requiresAuth: true
    },
    props: true
  },
  {
    path: "/Print/ShowPrintBaFinal",
    name: "PrintBaFinal",
    component:  () => import("@/components/Report/ShowPrintBaFinal.vue"),
    meta: {
        name: "PrintBaFinal",
        menuTitle: "Print BA Final",
        requiresAuth: true
    },
    props: true
  },
  {
    path: "/Print/ShowPrintWithoutSPO",
    name: "PrintWithoutSPO",
    component:  () => import("@/components/Report/ShowPrintWithoutSPO.vue"),
    meta: {
        name: "PrintWithoutSPO",
        menuTitle: "Print With out SPO",
        requiresAuth: true
    },
    props: true
  },
  {
    path: "/Print/ShowPrintRetensi",
    name: "PrintRetensi",
    component:  () => import("@/components/Report/ShowPrintBaRetensi.vue"),
    meta: {
        name: "PrintRetensi",
        menuTitle: "Print BAS Retensi",
        requiresAuth: true
    },
    props: true
  },
  {
    path: "/Print/ShowPrintProgressTermin",
    name: "PrintProgressTermin",
    component:  () => import("@/components/Report/ShowPrintProgressTermin.vue"),
    meta: {
        name: "PrintProgressTermin",
        menuTitle: "Print Progress Termin",
        requiresAuth: true
    },
    props: true
  },
  {
    path: "/Print/ShowPrintProgressFinal",
    name: "PrintProgressFinal",
    component:  () => import("@/components/Report/ShowPrintProgressFinal.vue"),
    meta: {
        name: "PrintProgressFinal",
        menuTitle: "Print Progress Final",
        requiresAuth: true
    },
    props: true
  },
  // Dihapus: duplikasi route ShowPrintAddendum
  {
    path: "/Report/ProgressReport",
    name: "ProgressReport",
    component:  () => import("@/components/Report/ProgressReport.vue"),
    meta: {
        name: "ProgressReport",
        menuTitle: "Document Progress Report",
        requiresAuth: true
    },
    props: true
  },
  {
    path: "/Report/SummaryReportWo",
    name: "SummaryReportWo",
    component:  () => import("@/components/Report/SummaryReportWo.vue"),
    meta: {
        name: "SummaryReportWo",
        menuTitle: "Summary Report Wo",
        requiresAuth: true
    },
    props: true
  },
  {
    path: "/Report/ProgressReportWo",
    name: "ProgressReportWo",
    component:  () => import("@/components/Report/ProgressReportWo.vue"),
    meta: {
        name: "ProgressReportWo",
        menuTitle: "Progress Report WO",
        requiresAuth: true
    },
    props: true
  },
  {
    path: "/Print/ShowPrintMC",
    name: "PrintMC",
    component:  () => import("@/components/Report/ShowPrintMC.vue"),
    meta: {
        name: "PrintMC",
        menuTitle: "Print MC",
        requiresAuth: true
    },
    props: true
  },
  {
    path: "/Print/ShowPrintBAPVA",
    name: "PrintBAPVA",
    component:  () => import("@/components/Report/ShowPrintBAPVA.vue"),
    meta: {
        name: "PrintBAPVA",
        menuTitle: "Print BAPVA",
        requiresAuth: true
    },
    props: true
  },
  {
    path: "/Print/ShowPrintRKTK",
    name: "PrintRKTK",
    component:  () => import("@/components/Report/ShowPrintRKTK.vue"),
    meta: {
        name: "PrintRKTK",
        menuTitle: "Print RKTK",
        requiresAuth: true
    },
    props: true
  },
];